<div id="errorBox" class="error-box-container hidden">
  <div class="error-box-title">{{title}}</div>
  <div class="error-box-content">
    <dx-scroll-view>
      @for (error of items; track error) {
        <div class="error-box-item" (click)="error.onClick('')">
          @if (error.type.toLowerCase() === 'fehler') {
            <div class="dx-icon-clear"></div>
          }
          @if (error.type.toLowerCase() === 'information') {
            <div class="dx-icon-info"></div>
          }
          @if (error.category !== undefined && error.category!== null && error.category.length > 0) {
            <div class="error-box-item-category">
            {{error.category}}</div>
          }
          {{error.message}}
        </div>
      }
    </dx-scroll-view>
  </div>
</div>